import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ApiService } from "src/app/services/api.service";

@Component({
  selector: "fury-customer-list",
  templateUrl: "./customer-list.component.html",
  styleUrls: ["./customer-list.component.scss"],
})
export class CustomerListComponent implements OnInit {
  @Input() columns: any[];
  @Input() itemList: any;
  @Input() dataSource: MatTableDataSource<any>;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @Output() search = new EventEmitter<any>();
  @Input() tabIndex: any;
  @Input() isLoading = false;

  @Input() customerSearchForm: FormGroup;
  constructor(public apiService: ApiService) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.dataSource) {
      this.sort.sort({ id: null, start: "desc", disableClear: false });
      this.announceSortChange();
    }
  }

  get visibleColumns() {
    return this.columns
      .filter((column) => column.visible)
      .map((column) => column.property);
  }
  searchData() {
    if (this.isLoading) return;
    this.search.emit(this.customerSearchForm.value);
  }
  ngAfterViewInit() {
    this.announceSortChange();
  }
  announceSortChange() {
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case "agreementNumber":
          return item?.address?.agreementNumber || item[property];
        case "zipCode":
          return item?.address?.zip || item[property];
        case "state":
          return item?.address?.state || item[property];
        case "address":
          return item?.address?.streetAddress || item[property];
        case "mobileNumber":
          return item?.phoneNumber || item[property];
        default:
          return item[property];
      }
    };
    this.dataSource.sort = this.sort;
  }

  handleRedirectToCustomerDashboard(consumerId){
    this.apiService.routeToPage(`customer-dashboard/${consumerId}`)
  }
}
